import { useNavigate } from "react-router-dom";
import { toast } from "@/ui";
import { useSession } from "./_shims";
import { useRefreshMatches } from "./lib/hooks";

export interface CommandItem {
  id: string;
  title: string;
  keywords: string[];
  shortcut?: string;
  run: () => void;
}

/**
 * Command bar entries. Call it during render of a component under the router (it uses navigation hooks), as the
 * command bar does.
 */
export function NetworkCommandItems(): CommandItem[] {
  const navigate = useNavigate();
  const { isSignedIn } = useSession();
  const refresh = useRefreshMatches();
  return [
    { id: "network.add-need", title: "Add a need", keywords: ["need", "want", "looking for", "ask"], shortcut: "w", run: () => navigate("/needs?new=1") },
    { id: "network.add-service", title: "Add an offer", keywords: ["service", "offer", "provide", "help with"], shortcut: "o", run: () => navigate("/services?new=1") },
    { id: "network.matches", title: "Go to introductions", keywords: ["introductions", "matches", "intros"], shortcut: "g m", run: () => navigate("/matches") },
    {
      id: "network.refresh",
      title: "Refresh introductions",
      keywords: ["discover", "rematch", "find matches"],
      run: () => {
        if (!isSignedIn) {
          toast("Sign in to refresh introductions.");
          return;
        }
        refresh.mutate(undefined, {
          onSuccess: (r) => toast(r.matchesFound > 0 ? `${r.matchesFound} new introduction${r.matchesFound === 1 ? "" : "s"} found.` : "No new introductions right now.", "success"),
          onError: (e) => toast(e instanceof Error ? e.message : "Could not refresh introductions.", "danger"),
        });
      },
    },
    { id: "network.ask", title: "Ask Hub", keywords: ["ask", "question", "who do i know", "assistant"], run: () => navigate("/ask") },
    { id: "network.directory", title: "Find people on Hub", keywords: ["network", "directory", "connections"], run: () => navigate("/network") },
    { id: "network.messages", title: "Open messages", keywords: ["messages", "chat", "inbox"], run: () => navigate("/messages") },
  ];
}
